import React from "react";
import { ReactComponent as RespectSvg } from "../../assets/icons/respect.svg";

export default function RespectIcon({ size = 20, className = "" }) {
  return (
    <RespectSvg
      className={className}
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      style={{
        display: "inline-block",
        verticalAlign: "middle",
      }}
    />
  );
}
